const globalUtils = {
  isLogin: false,
  isCustomer: false,
  isVisitingMapScreen: false
};

export default globalUtils;
